import { DefaultIconProps } from './default-icon/default-icon-props';
import { DefaultIcon } from './default-icon/default-icon';

export const DownloadIcon = (props: DefaultIconProps) => {
  return (
    <>
      <DefaultIcon
        tipo={props.tipo}
        class={props.class}
        style={props.style}
        fill={props.fill}
      >
        <path d="M10 20 L20 30 L30 20 L25 20 L25 10 L15 10 L15 20 Z" />
        <rect x="10" y="35" width="20" height="2" />
      </DefaultIcon>
    </>
  );
};
